import React from "react";
import "./HRBusinessSection.css";

const HRBusinessSection = () => {
  return (
    <section className="hrb-section">

      {/* LEFT CONTENT */}
      <div className="hrb-left">
        <p className="hrbs-subtitle">GET YOUR TEAM WORKING RIGHT</p>
        <h2 className="hrbs-title">
          Improve Your <br /> <span>Business</span>
        </h2>
        <p className="hrb-desc">
          Phosfluorescently engage worldwide methodologies with web-enabled
          technology. Interactively coordinate proactive e-commerce via
          process-centric "outside the box" thinking.
        </p>

        <button className="hrbs-btn">VIEW OUR PORTFOLIO</button>
      </div>

      {/* RIGHT IMAGE SHAPE */}
      <div className="hrb-right">
        <div className="hrb-image-wrapper">
          <img
            src="https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/img-team.png"
            alt="team"
            className="hrb-image"
          />
        </div>
      </div>

    </section>
  );
};

export default HRBusinessSection;
